function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "currentColor",
  d: "M5.571 2.283c-.652 0-1.154.514-1.154 1.117 0 .602.502 1.117 1.154 1.117h2.413a6.046 6.046 0 00-.352-.75c-.477-.849-1.137-1.484-2.06-1.484zM2.917 3.4c0 .4.09.779.252 1.117H1.533a.75.75 0 00-.75.75V9c0 .414.336.75.75.75h.85v6.716c0 .415.336.75.75.75h11.734a.75.75 0 00.75-.75V9.75h.85a.75.75 0 00.75-.75V5.267a.75.75 0 00-.75-.75H14.83c.162-.338.252-.716.252-1.117 0-1.46-1.203-2.617-2.654-2.617-1.743 0-2.798 1.232-3.369 2.25l-.06.11a6.658 6.658 0 00-.06-.11C8.368 2.015 7.314.783 5.57.783 4.12.783 2.917 1.941 2.917 3.4zm7.1 1.117h2.412c.652 0 1.154-.515 1.154-1.117 0-.603-.502-1.117-1.154-1.117-.924 0-1.584.635-2.06 1.484-.144.256-.26.514-.353.75zm-.267 1.5V8.25h5.967V6.017H9.75zm-4.179 0H8.25V8.25H2.283V6.017h3.288zm4.179 9.7h4.367V9.75H9.75v5.966zM8.25 9.75v5.966H3.883V9.75H8.25z"
})));